import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Icon from '../../../Icon';
import Loader from '../../../Loader';
import { CityContainer, CityLabel, LocationBarContainer } from './styled';
import ArrowRight from '../../../../public/static/images/item/arrow-right.svg';
import { setError } from '../../../../actions';
import { NewSearchLocationBarProps } from './types';
import { SearchTabs } from '../../../ui/SearchTabs';
import { TOWNSHIP_ID } from '../../../../utils/helpers/constants';
import { getTabsTitlesFromLocationGroups } from '../../../../utils/helpers/getTabsTitlesFromLocationGroups';
import { useCityAndLocationsQuery } from '../../../useCityAndLocationsQuery';

export const NewSearchLocationBar = ({
  openCitiesHandler,
  cityId,
  setLocationsIsLoading,
  children,
  searchString,
  chosenLocationIds,
  locationGroups,
  townshipsCount,
  currentTabId,
  setCurrentTabId
}: NewSearchLocationBarProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { data, loading, error } = useCityAndLocationsQuery(cityId);

  useEffect(() => {
    if (setLocationsIsLoading) {
      setLocationsIsLoading(loading);
    }
  }, [loading]);

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);

  const cityName =
    data && data.city !== null ? data.city?.name : t('search.city_search.any');

  const locationGroupsForTabs = locationGroups?.filter(
    group => group.id !== TOWNSHIP_ID
  );

  const tabsTitles = getTabsTitlesFromLocationGroups(
    locationGroupsForTabs,
    chosenLocationIds,
    townshipsCount
  );

  return (
    <LocationBarContainer>
      <CityContainer
        tabIndex={0}
        role="button"
        data-cy="city-container"
        data-stat="new-search-form__city"
        onClick={openCitiesHandler}
        onKeyPress={openCitiesHandler}
      >
        <Loader
          loading={loading}
          optionalClass="new-search-popup__top-tools_loader"
        >
          <CityLabel tag="body_1" data-cy="city-label">
            {t('new_search.your_city')}{' '}
            <CityLabel tag="body_1" data-cy="new-search-form__city_name">
              {cityName}
            </CityLabel>
          </CityLabel>
        </Loader>
        <Icon
          indent={false}
          height={12}
          width={10}
          IconComponent={ArrowRight}
        />
      </CityContainer>
      {locationGroupsForTabs?.length > 1 && (
        <SearchTabs
          currentTabId={currentTabId}
          switchTab={setCurrentTabId}
          titles={tabsTitles}
          disabled={!!searchString}
        />
      )}
      {children}
    </LocationBarContainer>
  );
};
